<pcs-modal>
  <pcs-modal-header class="justify-content-between">
    <h5 class="modal-title">{{titleText | translate}}</h5>
    <pcs-icon icon="close" aria-label="Close" size="iconM" (click)="onClose()"></pcs-icon>
  </pcs-modal-header>
  <pcs-modal-body>
    <form [formGroup]="form">
      <pcs-textarea formControlName="reason"
                    label="{{getMessage(props)}}">
      </pcs-textarea>
    </form>
  </pcs-modal-body>
  <pcs-modal-footer>
    <pcs-button [buttonText]="cancelButtonText"
                (clicked)="onClose()"
                buttonSize="small"></pcs-button>
    <pcs-button [disabled]="form.invalid"
                [buttonText]="buttonText"
                [buttonStyle]="props.componentStyle"
                (clicked)="onConfirm()"
                buttonSize="small"></pcs-button>
  </pcs-modal-footer>
</pcs-modal>
